import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Stack,
} from '@mui/material';
import PropTypes from 'prop-types';

const PrintConfigurationDisplay = ({ 
  printConfig, 
  showTitle = true,
  variant = 'default',
  size = 'medium'
}) => {
  const configItems = [
    { key: 'includeAcPayee', label: 'A/C Payee', shortLabel: 'AC' },
    { key: 'includeBeneficiary', label: 'Beneficiary', shortLabel: 'Ben' },
    { key: 'includeDate', label: 'Date', shortLabel: 'Date' },
    { key: 'includeAmount', label: 'Amount', shortLabel: 'Amt' },
    { key: 'includeAmountPrefix', label: 'Prefix **', shortLabel: 'Pfx' },
    { key: 'includeAmountSuffix', label: 'Suffix **', shortLabel: 'Sfx' },
    { key: 'includeNonNegotiable', label: 'Non Negotiable', shortLabel: 'NN' },
    { key: 'chequeSizedPdf', label: 'Cheque Sized', shortLabel: 'ChqPdf' },
    { key: 'excludeCurrencyWords', label: 'No Currency Word', shortLabel: 'NoCur' },
  ];

  const getChipSize = () => {
    switch (size) {
      case 'small': return 'small';
      case 'large': return 'medium';
      default: return 'small';
    }
  };

  const getChipLabel = (item) => {
    if (variant === 'compact') {
      return `${item.shortLabel}: ${printConfig[item.key] ? 'Y' : 'N'}`;
    }
    return `${item.label}: ${printConfig[item.key] ? 'Yes' : 'No'}`;
  };

  return (
    <Box sx={{ 
      mb: variant === 'inline' ? 0 : (variant === 'compact' ? 0.75 : 1), 
      p: variant === 'inline' ? 0 : (variant === 'compact' ? 0.5 : 0.75), 
      bgcolor: variant === 'inline' ? 'transparent' : (variant === 'compact' ? 'grey.25' : 'grey.50'), 
      borderRadius: variant === 'inline' ? 0 : 1, 
      border: variant === 'inline' ? 'none' : '1px solid', 
      borderColor: variant === 'inline' ? 'transparent' : 'grey.200' 
    }}>
      {showTitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: variant === 'compact' ? 0.25 : 0.5, fontSize: '0.875rem' }}>
          Print Configuration:
        </Typography>
      )}
      <Stack 
        direction="row" 
        spacing={variant === 'compact' ? 0.5 : 1} 
        flexWrap="wrap"
        useFlexGap
      >
        {configItems.map((item) => (
          <Chip 
            key={item.key}
            label={getChipLabel(item)}
            size={getChipSize()}
            color={printConfig[item.key] ? 'success' : 'default'}
            variant={variant === 'compact' ? 'filled' : 'outlined'}
            sx={{
              fontSize: variant === 'compact' ? '0.65rem' : '0.75rem',
              height: variant === 'compact' ? 18 : 24,
              '& .MuiChip-label': {
                px: variant === 'compact' ? 0.5 : 1,
              }
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

PrintConfigurationDisplay.propTypes = {
  printConfig: PropTypes.shape({
    includeAcPayee: PropTypes.bool,
    includeBeneficiary: PropTypes.bool,
    includeDate: PropTypes.bool,
    includeAmount: PropTypes.bool,
    includeAmountPrefix: PropTypes.bool,
    includeAmountSuffix: PropTypes.bool,
    includeNonNegotiable: PropTypes.bool,
    chequeSizedPdf: PropTypes.bool,
    excludeCurrencyWords: PropTypes.bool,
  }).isRequired,
  showTitle: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'compact', 'inline']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default PrintConfigurationDisplay; 